export const config = {

  // apiBaseURL:"http://192.168.42.206:8000",

  // apiBaseURL: "http://localhost:8000",

  apiBaseURL: window.location.origin,



};

// console.log(window.location.origin);
